import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Same-origin JSON from `public/i18n/` — works on any dev port (3000, 3001, …) and in production.
// Hardcoding localhost:3000 breaks translations when the app runs on another port (keys show as raw text).
const loadPath = '/i18n/{{lng}}.json';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        backend: {
            loadPath,
        },
    });

export default i18n;
